import { DepositsContext } from '@views/contexts'
import { useContext } from 'react'

export const useDeposits = () => useContext(DepositsContext)
